import { useEffect, useState } from 'react'
import { listCatalog, type CatalogClip } from './api'

export function useCatalog(filter: { keyword?: string; q?: string }): {
  clips: CatalogClip[]
  loading: boolean
  error: string | null
} {
  const [clips, setClips] = useState<CatalogClip[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let live = true
    setLoading(true)
    listCatalog(filter)
      .then((c) => {
        if (!live) return
        setClips(c)
        setError(null)
      })
      .catch((e) => {
        if (live) setError(String(e))
      })
      .finally(() => {
        if (live) setLoading(false)
      })
    return () => {
      live = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.keyword, filter.q])

  return { clips, loading, error }
}
